import { useEffect } from 'react'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import TableWithPagination from '../../../components/TableWIthPagination'
import { PAGE_SIZE } from '../../../config/consts'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom, TableAtom } from '../../../recoil/atoms'
import { calcOffset, parseNumber, roundDecimal } from '../../../utils/display'
import useGetPushNotificationStoreRank from '../hooks/useGetPushNotificationStoreRank'

function NotificationStoreRanking({ className }: { className?: string }) {
  const service = useRecoilValue(ServiceAtom)
  const tableOpt = useRecoilValue(TableAtom('shopRankings'))
  const resetTableOpt = useResetRecoilState(TableAtom('shopRankings'))
  const { form } = useLocationDateTimeForm()

  useEffect(() => {
    resetTableOpt()
  }, [form, resetTableOpt])

  // APIs
  const { pushNotificationStoreRank, pushNotificationStoreRankLoading } = useGetPushNotificationStoreRank({
    serviceId: service.value,
    fromDate: form.fromDate,
    toDate: form.toDate,
    offset: calcOffset(tableOpt.current, PAGE_SIZE),
    sortTarget: tableOpt.sortTarget ?? 2,
    isAsc: tableOpt.isAsc,
  })

  return (
    <CardWithBorder
      className={`${className} relative`}
      title='店舗別ランキング'
      visible={pushNotificationStoreRankLoading}
    >
      <TableWithPagination
        labels={['サイトID', 'サイト名', '配信数', '開封数', '開封率']}
        name='shopRankings'
        unSortableIndex={[0, 1]}
        rightAlignedColumns={[2, 3, 4]}
        columnWidths={['20%', '52%', '7%', '7%', '7%']}
        elements={
          pushNotificationStoreRank?.pushNotificationStoreRankDatas?.map((e) => [
            e.siteId?.toString() ?? e.siteId,
            e.siteName,
            `${parseNumber(e.pushNotificationCount)} 回`,
            `${parseNumber(e.pushNotificationOpenCount)} 回`,
            `${roundDecimal((e.pushNotificationOpenCTR * 100), 2)} %`,
          ]) ?? []
        }
        pageSize={PAGE_SIZE}
        total={pushNotificationStoreRank?.totalCount ?? 0}
      />
    </CardWithBorder>
  )
}

NotificationStoreRanking.defaultProps = {
  className: '',
}

export default NotificationStoreRanking
